







































































export default {
  props: {
    stageIndex: {
      type: Number,
      required: true,
    },
    site: {
      type: Object,
      required: true,
    },
    devices: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      isInitialLoading: true,
      isSavingData: false,
    }
  },

  computed: {},

  mounted: async function(): Promise<void> {
    this.isInitialLoading = false
    this.emitValidStatus()
  },
  beforeUpdate: async function(): Promise<void> {
    this.emitValidStatus()
  },

  methods: {
    isValid() {
      return true
    },
    emitValidStatus() {
      console.log('emitValidStatus(): ' + this.isValid())
      return this.$emit('stageIsValid', {
        stageIndex: this.stageIndex,
        isValid: this.isValid(),
      })
    },
    goBack() {
      this.$emit('update:stageIndex', this.stageIndex - 1)
    },
  },
}
